"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var data = {
  nav: [{
    text: '体验中心',
    key: '1',
    isActive: true,
    hasSub: true
  }, {
    text: '产品控制台',
    key: '2',
    isActive: false,
    hasSub: false
  }, {
    text: '产品文档',
    key: '3',
    isActive: false,
    hasSub: false
  }, {
    text: '需求反馈',
    key: '4',
    isActive: false,
    hasSub: false
  }],
  dropdownCaption: {
    title: '文字识别OCR',
    desc: '文字识别（Optical Character Recognition，OCR）OCR 支持身份证、名片等卡证类和票据类的印刷体识别，也支持运单等手写体识别，支持提供定制化服务，可以有效地代替人工录入信息。',
    link: '了解更多>'
  },
  dropdownMenu: [[{
    title: '通用文字识别',
    items: [{
      text: '通用印刷体'
    }, {
      text: '通用印刷体（高精度版）'
    }, {
      text: '通用手写体'
    }, {
      text: '英文'
    }, {
      text: '广告文字识别'
    }, {
      text: '表格识别v2'
    }, {
      text: '表格识别v3'
    }]
  }, {
    title: '智能结构化',
    items: [{
      text: '智能结构化'
    }, {
      text: '自定义结构化'
    }]
  }, {
    title: '通用文字智能',
    tag: '公测体验',
    items: [{
      text: '通用文字智能'
    }]
  }], [{
    title: '卡证文字识别',
    items: [{
      text: '身份证（人像面）'
    }, {
      text: '身份证（国徽面）'
    }, {
      text: '银行卡'
    }, {
      text: '护照（中国大陆地区护照）'
    }, {
      text: '护照（港澳台地区及境外护照）'
    }, {
      text: '港澳台通行证'
    }, {
      text: '港澳台来往内地通行证'
    }, {
      text: '港澳台居住证'
    }, {
      text: '驾驶证'
    }, {
      text: '行驶证（主页）'
    }, {
      text: '行驶证（副页）'
    }, {
      text: '营业执照'
    }]
  }, {
    title: '智能扫码',
    items: [{
      text: '二维码和条形码'
    }]
  }], [{
    title: '票据单据识别',
    items: [{
      text: '通用票据识别（高级版）'
    }, {
      text: '增值税发票'
    }, {
      text: 'OFD发票'
    }, {
      text: '运单'
    }, {
      text: '集装箱识别'
    }, {
      text: '医疗票据'
    }, {
      text: '完税证明'
    }, {
      text: '银行回单'
    }, {
      text: '网约车行程单'
    }]
  }, {
    title: '特定场景识别',
    items: [{
      text: '印章'
    }, {
      text: '车牌'
    }, {
      text: '车辆VIN码'
    }]
  }], [{
    title: '文本图像增强',
    items: [{
      text: '切边增强'
    }, {
      text: '去除阴影'
    }, {
      text: '去摩尔纹'
    }, {
      text: '提亮模式'
    }, {
      text: '文字锐化'
    }, {
      text: '灰度模式'
    }, {
      text: '黑白模式'
    }, {
      text: '省墨模式'
    }]
  }]],
  resultMenu: [{
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }, {
    title: '身份证（人像面)',
    desc: '支持二代身份证人像面所有字段的识别，包括姓名、性别等信息'
  }]
};
var _default = exports.default = data;